import { gql } from "@apollo/client";
import { captureException } from "@sentry/browser";

import { AppState } from "../reducers";

import { apollo, AppDispatch, AppThunk } from "./index";
import {
  INVENTORY_FILTER_INVENTORY,
  INVENTORY_SET_ERROR,
  INVENTORY_SET_INVENTORY,
  APP_LOADING_START,
  APP_LOADING_END,
} from "./types";

export const getInventory =
  (thenFilterByDishCategory: string | false = "Dish"): any =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: APP_LOADING_START });

      const req: any = await apollo().query({
        query: gql`
          {
            canteenFridgeAvailableInventoryForCompanyEntity {
              products {
                id
                localizedName
                available
                unavailabilityPublicMessage
                price
                localizedDescription
                vatRate
                pictureUrl
                servingSizeWeight
                isHot
                category
                localizedHeatingInstructions
                protein
                fat
                saturatedFat
                carbohydrate
                sugar
                dietaryFiber
                salt
                kilocalories
                kilojoules
                allergens {
                  localizedName
                }
                allergenTraces {
                  localizedName
                }
                brand {
                  name
                  key
                }
                localizedIngredientsList
                ingredients {
                  percentage
                  ingredient {
                    localizedName
                    ingredients {
                      percentage
                      ingredient {
                        localizedName
                      }
                    }
                  }
                }
                canteenTags {
                  localizedName
                  colorCode
                }
                promoteMobileApp
                lineOfferProductImageOverlay {
                  picture
                }
              }
            }
          }
        `,
      });

      const inventory = req.data.canteenFridgeAvailableInventoryForCompanyEntity;

      await dispatch({
        type: INVENTORY_SET_INVENTORY,
        inventory,
        filteredInventory: inventory,
        promoteProducts: inventory.products.filter((product: any) => product.promoteMobileApp),
      });

      if (thenFilterByDishCategory) {
        dispatch(filterInventory("Dish"));
      }
    } catch (err) {
      captureException(err);
      dispatch({ type: INVENTORY_SET_ERROR });
    } finally {
      dispatch({ type: APP_LOADING_END });
    }
  };

export const filterInventory =
  (category: string | null = null): AppThunk =>
  async (dispatch: AppDispatch, getState: () => AppState) => {
    const {
      inventory: { inventory },
    } = getState();

    if (category) {
      const filteredInventory = JSON.parse(JSON.stringify(inventory));

      filteredInventory.products = inventory.products.filter(
        (product: { category: string }) => product.category === category,
      );

      dispatch({
        type: INVENTORY_FILTER_INVENTORY,
        category,
        filteredInventory,
      });
    }
  };
